import { MDXProvider } from '@mdx-js/react';
import React from 'react';
import { Container } from 'rsuite';

import Gist from '../components/Gist/loadable';
import Footer from '../components/PageLayout/Footer';
import Header from '../components/PageLayout/Header';
import SidebarWrapper from '../components/PageLayout/Sidebar';

import { ContextProvider } from './context';

const shortcodes = { Gist };

export const wrapPageElement = ({ element, props }) => {
  const pathname = props?.location?.pathname || '';
  const isFullWidth = pathname.startsWith('/misc') || pathname.startsWith('/bookshelf') || pathname.startsWith('/calendar');

  return (
    <ContextProvider>
      <MDXProvider components={shortcodes}>
        <Header />
        <Container className="outerPadding">
          <Container className="container">
            {isFullWidth ? (
              <>
                <div>
                  {element}
                </div>
                <Footer />
              </>
            ) : (
              <SidebarWrapper>
                <div>
                  {element}
                </div>
                <Footer />
              </SidebarWrapper>
            )}
          </Container>
        </Container>
      </MDXProvider>
    </ContextProvider>
  );
};

// const ThemeProvider = (props) => {
//   const [themeMode, setThemeMode] = useTheme();
//   return (
//     <CustomProvider theme={themeMode}>
//       {props.children}
//     </CustomProvider>
//   );
// };
//
// export const wrapRootElement = ({ element }) => {
//   return (
//     <ThemeProvider>
//       {element}
//     </ThemeProvider>
//   );
// };
